import { Injectable, Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { AbstractRender } from 'src/app/abstract/render.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsRelatedinputModel } from 'src/app/models/widgets/widgets-related-input.model';
import { numericInputValidator } from 'src/app/validators/numeric-input.validator';
import { CloneService } from '../clone/clone.service';
import { WidgetRelatedInputComponent } from 'src/app/components/widgets/widget-related-input/widget-related-input.component';
/* eslint-disable */
@Injectable({
  providedIn: 'root',
})
export class RenderInputRelatedService extends AbstractRender {
  constructor(private injector: Injector, private logger: Logger) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(
    widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean
  ) {
    let input1 = widget as WidgetsRelatedinputModel;

    // A checkbox primitive has a label (optional), a multicheckbox and an other input (optional)
    let fieldGroupPrimitive: FormlyFieldConfig = {};
    // let fieldInput: FormlyFieldConfig = {
    //   key: input1.key,
    // };
    const fieldLabel: FormlyFieldConfig = {};
    let fieldPrefixOne: FormlyFieldConfig = {};
    let fieldPrefixTwo: FormlyFieldConfig = {};
    let fieldSuffix: FormlyFieldConfig = {};


    // Mix incoming template with the group
    if (input1.template) {
      const modelTemplate = JSON.parse(input1.template);
      // TODO: Check if this is really necessary
      fieldGroupPrimitive = Object.assign({}, fieldGroupPrimitive, modelTemplate);
      // fieldInput = Object.assign({}, fieldInput, modelTemplate);
    }
    // 1. Label Field

    // Override labels on Fields
    // Go up to custom model and overrides labels
    const labelOverrides: Map<string, string> = new Map<string, string>();
    CloneService.getLabelOverrides(input1, widgetRoot, labelOverrides);
    const overridedString = CloneService.overrideText(
      input1.label,
      labelOverrides
    );
    if (input1.label) {
      fieldLabel.template = overridedString;
    }

    //  config.push(fieldLabel)

    // 2. Prefix
    if (input1.prefix && input1.prefix !== '') {
      fieldPrefixOne = {
        template: '<span>' + input1.prefix + '</span>',
        className: 'prop-prefix'
      };
    }
    if (input1.middlePrefix && input1.middlePrefix !== '') {
      fieldPrefixTwo = {
        template: '<span>' + input1.middlePrefix + '</span>',
        className: 'prop-text'
      };
    }
    //  let temp = input1.key + 'to'  
    // 2. To
    const fieldTo: FormlyFieldConfig = {};
    fieldTo.key = input1.totalNumberKey ? input1.totalNumberKey : input1.key + 'To';
    fieldTo.type = 'uw-input';
    fieldTo.className = 'prop-to';

    if (input1.validInputs && input1.validInputs.length > 0) {
      fieldTo.props = {
        required: true,
        type: 'text',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'text',
        },
        validInputs: input1.validInputs
      };
      fieldTo.validators = { validation: ['arrayRegexValidation'] };
    } else if (input1.maxTextLength) {
      const maxFunction =
        "{ if (this.value.length >" + input1.maxTextLength
        + ") { this.value = this.value.slice(0, " + input1.maxTextLength
        + "); } }";
      fieldTo.props = {
        required: true,
        type: 'number',
        min: input1.min,
        max: input1.max,
        maxLength: input1.maxTextLength,
        // keypress: (field, event) => numericInputValidator(field, event),
        keyEnforce: 'numericInput',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'numeric',
          onInput: maxFunction
        }
      };
    } else {
      fieldTo.props = {
        required: true,
        type: 'number',
        // keypress: (field, event) => numericInputValidator(field, event),
        keyEnforce: 'numericInput',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'numeric'
        }
      };
    }

    // 1. From
    const fieldFrom: FormlyFieldConfig = {};
    fieldFrom.key = input1.sequenceNumberKey ? input1.sequenceNumberKey : input1.key + 'From';
    fieldFrom.type = 'uw-input';
    fieldFrom.className = 'prop-from';
    if (input1.validInputs && input1.validInputs.length > 0) {
      fieldFrom.props = {
        required: true,
        type: 'text',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'text',
        },
        validInputs: input1.validInputs
      };
      fieldFrom.validators = { validation: ['arrayRegexValidation'] };
    } else if (input1.maxTextLength) {
      const maxFunction =
        "{ if (this.value.length >" + input1.maxTextLength
        + ") { this.value = this.value.slice(0, " + input1.maxTextLength
        + "); } }";
      fieldFrom.props = {
        required: true,
        type: 'number',
        min: input1.min,
        max: input1.max,
        maxLength: input1.maxTextLength,
        // keypress: (field, event) => numericInputValidator(field, event),
        keyEnforce: 'numericInput',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'numeric',
          onInput: maxFunction,
        }
      };
    } else {
      fieldFrom.props = {
        required: true,
        type: 'number',
        // keypress: (field, event) => numericInputValidator(field, event),
        keyEnforce: 'numericInput',
        attributes: {
          onpaste: 'return ' + input1.isPasteEnabled + ';',
          inputmode: 'numeric'
        }
      };
    }


    // 4. Suffix
    if (input1.suffix && input1.suffix !== '') {
      fieldSuffix = {
        template: '<span>' + input1.suffix + '</span>',
        className: 'prop-suffix'
      };
    }

    // 5. Prepare groups
    fieldGroupPrimitive.fieldGroupClassName = 'primitive-related-input';
    fieldGroupPrimitive.fieldGroup = [];

    // 6. Render
    if (input1.label && input1.label !== '') {
      fieldLabel.className = 'prop-label';
      fieldGroupPrimitive.fieldGroup?.push(fieldLabel);
    }
    // Validation
    for (const validation of input1.children) {
      try {
        const valTemplate: string = validation.getTemplate();
        if (valTemplate) {
          const template = JSON.parse(valTemplate);
          fieldFrom.validators = {
            validation: [template],
          };
          // FIXME: Check if validation is only for fieldTo or for form...
          if (template.name === 'timeRange') {
            // else if it is for whole form...
            const validators = { validators: { validation: [template] } };

            // FIXME: For now apply at the root level for date validation
            formlyRoot.validators = { validation: [template] };
            // rootValidation.push( template );
          } else {
            // Else apply at the fieldTo level
            fieldFrom.validators = {
              validation: [template],
            };
          }
        }
      } catch (err) {
        this.logger.warn('validation exeception:' + err);
      }
    }

    if (input1.validInputs && input1.validInputs.length > 0) {
      // Need to Add validation for form component
    } else if (input1.unrelatedFlag) {
      // unrelated 
    } else {
      fieldGroupPrimitive.validators = {
        validation: [
          {
            name: 'relatedInputValidation', options: {
              errorPath: input1.sequenceNumberKey ? input1.sequenceNumberKey : input1.key + 'From'
            }
          }
        ]
      }
    }

    fieldGroupPrimitive.fieldGroup = [
      fieldLabel, fieldPrefixOne, fieldFrom, fieldPrefixTwo, fieldTo, fieldSuffix
    ];
    // Wrapper For field
    fieldGroupPrimitive.wrappers = ['field'];

    // 7. Push the group to the formly structure
    config.push(fieldGroupPrimitive);
  }
}

